/* eslint-disable max-lines */
/* TODO: remove the above line and reduce the line count */

import * as Sentry from '@sentry/browser';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';


import { isSpecialKey } from './compatibility';
import { calculateAllConsultationFields, manageExistingPatient } from './consultations';
import { addUppyFieldsToForm } from './filesUpload';
import { conditionalField } from './forms';
import { pushToReactSnackbar, store } from './reactTreeMounting';
import i18n from 'FRONTEND/utils/i18n';

dayjs.extend(calendar);

const excludedFields = [
  'patient-patient_id',
  'patient-patient_type',
  'patient-patient_type_anonymous',
  'patient-patient_type_existing',
  'patient-project_id',
  'patient-tenant_id',
];


/** ****************************** */
/** ********* Utilities ********** */
/** ****************************** */

function getConsultationData($form) {
  /**
   * Returns current page's consultation form data in an object.
   */
  const consultationData = {};
  let emptyForm = true;

  // Only gets: inputs except 'checkbox' and 'radio', select elements that don't have 'multiple' attribute and textareas.
  const serializedForm = $form.serializeArray();
  serializedForm.forEach(field => {
    if (field.name === 'csrf_token') {
      return;
    }
    const fieldName = field.name;
    consultationData[fieldName] = field.value;
    if (!excludedFields.includes(fieldName) && consultationData[fieldName]) {
      emptyForm = false;
    }
  });

  // Checkboxes.
  $('input:checkbox').each(function saveCheckbox() {
    const fieldName = $(this).attr('id');
    consultationData[fieldName] = $(this).prop('checked');
    if (!excludedFields.includes(fieldName) && consultationData[fieldName]) {
      emptyForm = false;
    }
  });

  // Radios.
  $('input:radio').each(function saveRadio() {
    const fieldName = $(this).attr('id');
    consultationData[fieldName] = $(this).prop('checked');
    if (!excludedFields.includes(fieldName) && consultationData[fieldName]) {
      emptyForm = false;
    }
  });

  // Multiple selects.
  $('select').each(function saveMultipleSelectField() {
    if (!$(this).attr('multiple')) {
      return;
    }
    const fieldName = $(this).attr('id');
    consultationData[fieldName] = $(this).val();
    if (!excludedFields.includes(fieldName) && consultationData[fieldName].length !== 0) {
      emptyForm = false;
    }
  });

  // Add timestamp.
  consultationData.saved_at = dayjs().format();

  return { consultationData, emptyForm };
}

function testIfFilePresent() {
  /**
   * Check if there are any files present in the form.
   * @type {boolean}
   */
  let emptyFiles = true;

  $('input:file').each(function testFileInput() {
    const file = $(this).prop('files');
    if (file.length) {
      emptyFiles = false;
      return false;
    }
  });

  return emptyFiles;
}

/** ****************************** */
/** * Save draft to localStorage * */
/** ****************************** */

function saveLocalDraft(consultationData) {
  /**
   * Save consultation form draft to localStorage (key = <user_id>_<url_pathname>).
   */
  const storageKey = `${window.userId}_${window.location.pathname}`;
  window.localStorage.setItem(storageKey, JSON.stringify(consultationData));

  return storageKey;

  // Deactivate saving transitions for the moment.
  /* if (CONSULTATIONS_READ_PATH.test(pathname)) {
    $('form').each(function saveFormToLocalStorage() {
      const formId = $(this).attr('id');
      if (formId) {
        consultationData = getConsultationData($(this));
        // We add the transition name to the pathname to get localStorage key for consultation transitions fields.
        const basePathname = CONSULTATIONS_READ_PATH.exec(pathname)[0];
        const transitionName = formId.split('-')[1];
        key = `${window.userId}_${basePathname}${transitionName}/`;
        window.localStorage.setItem(key, JSON.stringify(consultationData));
      }
    });
  } */
}

/** ****************************** */
/** ********* Save draft ********* */
/** ****************************** */

export async function saveDraft() {
  /**
   * Save current consultation as draft, either to the server or in local storage.
   */
  const draftForm = $('.consultations-draft').get(0);
  if (!draftForm) {
    return;
  }
  // OLM 01/11/2020: This isn't great, but I don't see a better way of knowing if
  // we are creating a new consultation (=> don't save empty) or if we are updating
  // a draft (=> save even if empty).
  const isNewConsultation = Boolean($('#consultations-create').length);

  // As we add uppy files to the draft sent to the server and as we can't save them to local storage:
  // * first save the draft to local storage
  // * then add the files to the form
  // * send the form to the server
  // * if the post succeeds, delete the form from the local storage
  // * if the post fails, we have the local storage version.
  let localDraft = null;
  const { consultationData, emptyForm } = getConsultationData($(draftForm));
  const saveLocally = !emptyForm || !isNewConsultation;
  if (saveLocally) {
    localDraft = saveLocalDraft(consultationData);
  }

  // In "create_without_patient":
  // * MSF context: if the user doesn't belong to any project
  // * Non-MSF: the user can't create patients and there is no patient on his tenant.
  // In those 2 cases, we won't be able to save the draft to the server.
  // So we only save it to local storage.
  const patientError = $('#patient_error');
  if (saveLocally && patientError.length) {
    return { message: i18n._('Draft saved locally.'), variant: 'success' };
  }

  addUppyFieldsToForm(draftForm);
  const emptyFiles = testIfFilePresent($(draftForm));
  if (emptyForm && emptyFiles && isNewConsultation) {
    return;
  }

  try {
    // form.action seems to be eaten by the action bar, so we need to use getAttribute('action').
    const draftUrl = new URL(draftForm.getAttribute('action'), window.location.origin);
    draftUrl.searchParams.append('d', 'True');
    const res = await fetch(draftUrl.href, {
      method: 'POST',
      body: new FormData(draftForm),
    });

    if (res.status === 200 || res.status === 201) {
      if (localDraft) {
        window.localStorage.removeItem(localDraft);
      }
      // JSON containing the notification message to display if any.
      return res.json();
    } else {
      return { message: i18n._('Draft saved locally.'), variant: 'success' };
    }
  } catch {
    return { message: i18n._('Draft saved locally.'), variant: 'success' };
  }
}

/** ****************************** */
/** ****** Save draft events ***** */
/** ****************************** */

window.onbeforeunload = () => {
  /**
   * Save draft when refreshing or closing consultation page.
   */
  if (!window.isLoggingOut) {
    saveDraft().then();
  }
};

// Save draft when any link is clicked, excluding actionBar.
$(document).on('click', 'a[data-pjax]:not(.actionBar a)', function onPjaxClick(event) {
  // Special keys lead to links being opened in a new tab/window/save page, so they shouldn't lead to a draft save.
  if (isSpecialKey(event)) {
    return;
  }

  saveDraft().then(result => {
    if (result?.message) {
      pushToReactSnackbar({ variant: result.variant, message: result.message });
    }
  });
});

/** ********************************* */
/** ** Load draft from localStorage * */
/** ********************************* */

export function confirmLoadLocalDraft() {
  /**
   * Load consultation form draft on the associated page.
   */
  const draftForm = $('.consultations-draft').get(0);
  if (!draftForm) {
    return;
  }

  removeAllLocalDrafts({ keepCurrentUserDrafts: true });

  const draftKey = `${window.userId}_${window.location.pathname}`;
  const previousDraft = window.localStorage.getItem(draftKey);

  if (previousDraft) {
    try {
      const locale = store?.getState().user.locale || window.userLocale;
      const savedAt = JSON.parse(previousDraft).saved_at;
      const formattedSavedAt = dayjs(savedAt).locale(locale).calendar();

      const savedAtDiv = $('#consultation_local_draft_saved_at');
      const replacedText = savedAtDiv.text().replace('__DRAFT_DATE__', formattedSavedAt);
      savedAtDiv.text(replacedText);

      $('#consultation_local_draft-load-modal').modal();
    } catch (error) {
      Sentry.captureException(error, { jsonData: previousDraft });
    }
  }

  /* if (CONSULTATIONS_READ_PATH.test(pathname)) {
    const forms = $('form');

    if (forms.length) {
      forms.each(function loadFormFromLocalStorage() {
        const formId = $(this).attr('id');
        if (formId) {
          const key = `${window.userId}_${pathname}${formId.split('-')[1]}/`;
          previousDraft = JSON.parse(window.localStorage.getItem(key));

          if (isPreviousDraftDifferent(previousDraft, $(this))) {
            loadLocalDraft(key);
          }

          window.localStorage.removeItem(key);
        }
      });
    } else {
      // Remove remaining drafts if consultation was diagnosed or closed by another user.
      for (const key in window.localStorage) {
        if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
          const oldDraftKeyRadix = window.userId + '_' + window.location.pathname;
          if (key.startsWith(oldDraftKeyRadix)) {
            window.localStorage.removeItem(key);
          }
        }
      }
    }
  } */
}

function loadLocalDraft(key) {
  /**
   * Load fields from localStorage and populate form inputs.
   */
  let consultationData;
  try {
    consultationData = JSON.parse(window.localStorage.getItem(key));
  } catch (error) {
    const context = {
      key,
      localStorage: window.localStorage,
      consultation: window.localStorage.getItem(key),
    };
    Sentry.captureException(error, context);
    return;
  }

  Object.keys(consultationData).forEach(fieldId => {
    if (consultationData[fieldId]) {
      const escapedId = fieldId.replace('/', '\\/');
      const element = $(`#${escapedId}`);

      if (element.attr('type') === 'checkbox' || element.attr('type') === 'radio') {
        element.prop('checked', consultationData[fieldId] === true);
      } else if (element.attr('multiple')) {
        // Multi-select.
        element.val(consultationData[fieldId]).trigger('change');
      } else {
        element.val(consultationData[fieldId]).trigger('change');
      }

      // Manage conditionalShowing and conditionalDisabling fields.
      if (element.attr('name') === 'patient-patient_type') {
        manageExistingPatient();
      } else {
        conditionalField(element);
      }

      // Open panel if there is at least one field which is populated.
      const panelBody = element.closest('.panel-collapse');
      if (panelBody && !panelBody.hasClass('in')) {
        panelBody.addClass('in');
      }

      // Specific to NPI ES buttons: press button indicated by hidden input.
      const groupButtons = $(`[data-input="${fieldId}"]`);
      groupButtons.each(function pressGroupSelectedButton() {
        if ($(this).data('value') === consultationData[fieldId]) {
          $(this).removeClass('btn-default');
          $(this).addClass('btn-primary');
        }
      });
    }
  });

  // 79 workflow specific fields.
  const NPIPresence = $('.npi_es_presence');
  if (NPIPresence.length) {
    NPIPresence.trigger('change');
  }

  calculateAllConsultationFields();
}

/** ********************************** */
/** * Load localStorage draft modals * */
/** ********************************** */

// User confirmed draft removal.
$(document).on('click', '#consultation_local_draft-delete-validate', function modalRemoveDraft() {
  const key = `${window.userId}_${window.location.pathname}`;
  window.localStorage.removeItem(key);
});

// User accepted draft load.
$(document).on('click', '#consultation_local_draft-load-validate', function modalLoadDraft() {
  const key = `${window.userId}_${window.location.pathname}`;
  loadLocalDraft(key);
  window.localStorage.removeItem(key);
});

/** ****************************** */
/** * Remove localStorage drafts * */
/** ****************************** */

/* function removeSpecificDraft(pathname) {
  /!**
   * Remove previously stored fields from localStorage for a given consultation page.
   *!/
  window.localStorage.removeItem(pathname);

  if (CONSULTATIONS_READ_PATH.test(pathname)) {
    window.localStorage.removeItem(pathname);

    const keyRadix = CONSULTATIONS_READ_PATH.exec(pathname)[0];

    // For consultations-read the draft key for a given transition is <user_id>_<url_pathname>/<transition name>.
    Object.keys(window.localStorage).forEach(function removeOtherTransitionsDraft(key) {
      if (key.split(keyRadix).length > 1) {
        window.localStorage.removeItem(key);
      }
    });
  }
} */

// Remove data from localStorage when submit succeeds.
$(document).on('pjax:success', function deleteLocalDraftOnSubmit(event) {
  const relatedElement = $(event.relatedTarget);
  if (relatedElement && relatedElement.attr('action')) {
    const url = new URL(relatedElement.attr('action'), 'https:/placeholder');
    const key = `${window.userId}_${url.pathname}`;
    window.localStorage.removeItem(key);
  }
});

export function removeAllLocalDrafts({ keepCurrentUserDrafts = false }) {
  for (const key in window.localStorage) {
    if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
      const splitKey = key.split('_');

      // dataTables localStorage format: DataTables_<listed data>_<URL pathname>.
      // Draft localStorage key is ${userId}_${pathname} and the pathname always contains '/consultations'.
      let shouldRemoveItem = splitKey.length > 1 && splitKey[0] !== 'DataTables' && splitKey[1].includes('/consultations');
      if (keepCurrentUserDrafts) {
        shouldRemoveItem = shouldRemoveItem && splitKey[0] !== window.userId;
      }

      if (shouldRemoveItem) {
        window.localStorage.removeItem(key);
      }
    }
  }
}
